module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.7f1320f7ec4f6716054d.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_regular_macroman/Roboto-Regular-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/roboto_regular_macroman/Roboto-Regular-webfont.ttf
// module chunks = 1